/** "Seu desempenho": o cliente vê o próprio crescimento (só leitura). Onda 18 v2. */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { api } from "../../lib/api";
import type { Metric } from "../../lib/metrics";
import { GrowthPanel } from "../../ui/GrowthPanel";
import { FullScreenLoader } from "../../ui/ProtectedRoute";

export function Desempenho() {
  const navigate = useNavigate();
  const [metrics, setMetrics] = useState<Metric[] | null>(null);

  useEffect(() => {
    api
      .get<{ metrics: Metric[] }>("/approval/dashboard")
      .then((d) => setMetrics(d.metrics))
      .catch(() => setMetrics([]));
  }, []);

  if (metrics === null) return <FullScreenLoader />;

  return (
    <div className="app-shell min-h-dvh px-5 py-6">
      <div className="mx-auto w-full max-w-3xl">
        <button
          type="button" onClick={() => navigate("/aprovacoes")}
          className="type-caption text-text-tertiary"
        >
          ← Voltar
        </button>
        <h1 className="type-h2 mt-1 text-text-cream">Seu desempenho</h1>
        <p className="type-body-sm mt-1 text-text-secondary">Sua evolução desde o início do projeto.</p>

        {metrics.length === 0 ? (
          <p className="type-body mt-8 text-text-secondary">
            Ainda não há dados registrados. Assim que houver, seu crescimento aparece aqui.
          </p>
        ) : (
          <div className="mt-4">
            <GrowthPanel metrics={metrics} />
          </div>
        )}
      </div>
    </div>
  );
}
